/**
 * Landing-page section reveal. Same timing as live EU (DOMContentLoaded +
 * IntersectionObserver at 0.2). Loaded from the image-sequence section,
 * so it applies on every template that uses that section.
 */
function initLandingReveal() {
  if (document.documentElement.dataset.landingRevealInit === 'true') return;
  document.documentElement.dataset.landingRevealInit = 'true';

  const main = document.getElementById('MainContent') || document.querySelector('main');
  if (!main) return;

  const sections = main.querySelectorAll('.shopify-section');
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    },
    {
      threshold: 0.2,
    }
  );

  sections.forEach((section) => {
    const rect = section.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    if (rect.top < viewportHeight * 0.8 && rect.bottom > 0) {
      section.classList.add('visible');
    }
    observer.observe(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLandingReveal);
} else {
  initLandingReveal();
}
